import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';
import { camelCaseObjectKeys } from 'utils/camelCase';

const utmParametersSlice = createSlice({
  name: 'utmParameters',
  initialState: {
    isLoading: LoadingStatus.Idle,
  },
  reducers: {
    apply: (state, action) => {
      const utm = camelCaseObjectKeys(action.payload);

      state.utmSource = utm.utmSource;
      state.utmMedium = utm.utmMedium;
      state.utmCampaign = utm.utmCampaign;
      state.utmTerm = utm.utmTerm;
      state.utmContent = utm.utmContent;
      state.entranceUrl = utm.entranceUrl;
      state.googleClickId = utm.googleClickId;
      state.httpReferer = utm.httpReferer;
      state.refer = utm.refer;
      state.isLoading = LoadingStatus.Succeeded;
    },
    fetch: (state) => {
      state.isLoading = LoadingStatus.Loading;
    },
    handleError: (state) => {
      state.isLoading = LoadingStatus.Failed;
    },
  },
});

// Extract the action creators object and the reducer
export default utmParametersSlice;
